import styled from 'styled-components'
import theme from '../../styles/theme.css'

export const ContainerP = styled.div`
    max-width: 680px;
    width: 90%;
    margin: 0.5rem auto;
    text-align: center;
    font-size: 1.2rem;
    p{
      font-family: ${theme.apercuProBold};
      font-weight: bold;
    }
`